import React, { useState } from "react";
import {ref, push} from "firebase/database";
import { db } from "../../../firebase";
import { useAuth } from "../../contexts/AuthContext";
import "./FormRegister.css";
// 请确保 firebase.js 中导出了 Realtime Database 实例
/*
  FormRegisterCN 组件用于收集用户信息并将数据保存到 Firebase Realtime Database。
  用户需填写全名、邮箱、电话号码、年龄、（根据年龄）监护人或领队同意、营区选择及留言，所有字段均为必填项。
  如果年龄为 "8-11"，必须填写监护人姓名、电话和邮箱；如果年龄为 "12-16" 或 "16-18"，需要同意由授权团队领队陪同。
*/
/*
  FormRegisterCN 组件用于收集用户信息并将数据保存到 Firebase Realtime Database。
  用户需填写全名、邮箱、电话号码及留言，所有字段均为必填项。
  同时将当前登录用户的 ID 一并保存，便于后续关联。
*/
const FormRegister = () => {
  // 初始化表单数据状态，包含全名、邮箱、电话号码和留言
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    age:"",
    guardianName:"",
    guardianPhone:"",
    guardianEmail:"",
    camps:"",
    message: "",
    teamLeaderConsent:false,//对于12-18岁需要勾选同意项
  });
  // 状态用于指示表单提交过程是否在进行中
  const [loading, setLoading] = useState(false);
  // 获取当前登录用户信息（例如 uid）
  const { currentUser } = useAuth();

  // 解构 formData 以便于在 JSX 中直接使用各个字段
  const { 
    fullName, 
    email, 
    phoneNumber, 
    age, 
    guardianName,
    guardianPhone,
    guardianEmail,
    camps, 
    message,
    teamLeaderConsent, 
  } = formData;

  /*
    handleChange 函数用于处理输入框变化事件，
    根据输入框的 name 属性更新对应的状态值。
  */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // 对于复选框使用 checked 值
    // 更新 formData 状态，保持其他字段不变
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // 將 email 或其他字串轉為 Firebase key-friendly 格式
  const sanitizeKey = (str) =>
    str.trim().replace(/\s+/g, "_").replace(/[^\w-]/g, "_");

  /*
    handleSubmit 函数用于处理表单提交事件：
      - 阻止默认表单提交行为
      - 检查所有必填字段是否填写
      - 将数据保存到 Firebase Realtime Database 中，同时存入当前用户的 ID
      - 根据操作结果显示成功或错误提示，并清空表单数据（成功时）
  */
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 如果任一字段为空，则提示用户填写所有字段
    if (!fullName || !email || !phoneNumber || !age ||!camps
      //  || !message
      ) {
      alert("Please fill in all fields");
      return;
    }
    // 针对年龄的额外验证：
    // 若年龄为 "8-11"，必须填写监护人信息
    if (age === "8-11") {
      if (!guardianName || !guardianPhone || !guardianEmail) {
        alert("For applicants aged 8-11, please fill in all guardian information.");
        return;
      }
    }
    // 若年龄为 "12-16" 或 "16-18"，必须勾选同意由授权团队领队陪同
    if (age === "12-15" || age === "16-18") {
      if (!teamLeaderConsent) {
        alert("For applicants aged 12-18, please agree that an authorized team leader will accompany your trip.");
        return;
      }
    }
    // 开始提交操作，开启加载状态
    setLoading(true);

    try {
            // 使用登入郵箱作為資料庫節點 ID
            // 将数据保存到 Realtime Database 的 "campregisterform" 节点下

            const userEmail = currentUser?.email || email;
            const emailKey = sanitizeKey(userEmail);
            const formRef = ref(db, `campregisterform/${emailKey}`);

      // 使用 push 将数据存入数据库
      await push(formRef, {
        fullName,
        email,
        phoneNumber,
        age,
        // 根据年龄保存监护人信息（仅当年龄为 "8-11" 时有效，否则为空字符串）
        guardianName: age === "8-11" ? guardianName : "",
        guardianPhone: age === "8-11" ? guardianPhone : "",
        guardianEmail: age === "8-11" ? guardianEmail : "",
        // 保存团队领队同意状态（仅当年龄为 "12-16" 或 "16-18" 时有效）
        teamLeaderConsent: (age === "12-15" || age === "16-18") ? teamLeaderConsent : false,

        camps,
        message,
        createdAt: Date.now(),
        // 使用客户端时间，如果需要服务器时间请使用相应方式
        userId: currentUser ? currentUser.uid : null, 
        // 如果用户已登录，则保存用户 ID；否则保存 null
      });
      console.log("Form data saved successfully!");
      alert("your register Form submitted successfully!");
      // 清空表单数据
      setFormData({
        fullName: "",
        email: "",
        phoneNumber: "",
        age:"",
        guardianName: "",
        guardianPhone: "",
        guardianEmail: "",
        camps:"",
        message: "",
        teamLeaderConsent: false,
      });
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Failed to submit form. Please try again later.");
    } finally {
      // 无论成功或失败，都关闭加载状态
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      {/* 页面标题 */}
      <h2>Camp Register Form</h2>
      {/* 表单区域 */}
      <form onSubmit={handleSubmit}>
        {/* 全名输入 */}
        <div>
          <label htmlFor="fullName">Full Name:</label>
          <input
            id="fullName"
            name="fullName"
            type="text"
            value={fullName}
            onChange={handleChange}
            required
          />
        </div>
        {/* 邮箱输入 */}
        <div>
          <label htmlFor="email">Email:</label>
          <input
            id="email"
            name="email"
            type="email"
            value={email}
            onChange={handleChange}
            required
          />
        </div>
        {/* 电话号码输入 */}
        <div>
          <label htmlFor="phoneNumber">Phone Number:</label>
          <input
            id="phoneNumber"
            name="phoneNumber"
            type="text"
            value={phoneNumber}
            onChange={handleChange}
            required
          />
        </div>
        {/* 年龄下拉菜单 */}
        <div>
          <label htmlFor="age">Age:</label>
          <select
            id="age"
            name="age"
            value={age}
            onChange={handleChange}
            required
          >
            <option value="">Select Age</option>
            <option value="8-11">8-11</option>
            <option value="12-15">12-15</option>
            <option value="16-18">16-18</option>
            <option value="18+">18+</option>
          </select>
        </div>
        {/* 如果年龄为 8-11，则显示监护人信息输入项 */}
        {age === "8-11" && (
          <div className="guardian-info">
            <p>Applicants under 12 must be accompanied by a guardian. Please provide guardian information:</p>
            <div>
              <label htmlFor="guardianName">Guardian Name:</label>
              <input
                id="guardianName"
                name="guardianName"
                type="text"
                value={guardianName}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label htmlFor="guardianPhone">Guardian Phone:</label>
              <input
                id="guardianPhone"
                name="guardianPhone"
                type="text"
                value={guardianPhone}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label htmlFor="guardianEmail">Guardian Email:</label>
              <input
                id="guardianEmail"
                name="guardianEmail"
                type="email"
                value={guardianEmail}
                onChange={handleChange}
                required
              />
            </div>
          </div>
        )}
                {/* 如果年龄为 12-16 或 16-18，则显示授权团队领队作为监护人的同意勾选项 */}
                {(age === "12-15" || age === "16-18") && (
          <div className="team-leader-consent">
            <p>Applicants aged between 12 and 18 require an authorized team leader to act as guardian.</p>
            <div>
              <input
                id="teamLeaderConsent"
                name="teamLeaderConsent"
                type="checkbox"
                checked={teamLeaderConsent}
                onChange={handleChange}
                required
              />
              <label htmlFor="teamLeaderConsent">I agree that an authorized team leader will accompany me.</label>
            </div>
          </div>
        )}
        {/* 下拉菜单，选择营区（camps） */}
        <div>
          <label htmlFor="camps">Camps:</label>
          <select
            id="camps"
            name="camps"
            value={camps}
            onChange={handleChange}
            required
          >
            <option value="">Please select a camp which you like join</option>
            <option value="USA-Florida">放飛一夏 - 歡樂美國夏令營</option>
            <option value="USA-Indip">行者無疆 - 250年的美國獨立之路</option>
            <option value="Germany-Industry">管中窺豹 - 德國高等教育與製造產業概覽</option>
            <option value="USA-Bus">世紀前沿 - 美國商業教育與企業</option>
            <option value="Asia-T-J">古今輝映 - 東亞的悠久與新興</option>
            <option value="Asia-China">浩瀚历史 - 中国名胜古迹精華瀏覽</option>
          </select>
        </div>
        {/* 留言输入 */}
        <div>
          <label htmlFor="message">Message:</label>
          <textarea
            id="message"
            name="message"
            value={message}
            onChange={handleChange}
            required
          />
        </div>
        {/* 提交按钮，加载时禁用，并显示不同文本 */}
        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default FormRegister;